// USAGE:
//      window.addEventListener("resize",debounce(function(e){
//          // do somthing every 100 ms
//      }));


export function debounce(func,time=100){
    var timer;
    return function(event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func,time,event);
    };
}
